<script setup>
import { computed, onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import OperationalMetricsApi from 'dashboard/api/operationalMetrics';

const { t } = useI18n();
const metrics = ref({});
const isLoading = ref(true);

const cards = computed(() => [
  {
    key: 'awaiting_service',
    label: t('CONVERSATION.OPERATIONS.METRICS.AWAITING_SERVICE'),
    value: metrics.value.awaiting_service || 0,
  },
  {
    key: 'in_service',
    label: t('CONVERSATION.OPERATIONS.METRICS.IN_SERVICE'),
    value: metrics.value.in_service || 0,
  },
  {
    key: 'waiting_customer',
    label: t('CONVERSATION.OPERATIONS.METRICS.WAITING_CUSTOMER'),
    value: metrics.value.waiting_customer || 0,
  },
  {
    key: 'closed',
    label: t('CONVERSATION.OPERATIONS.METRICS.CLOSED_30_DAYS'),
    value: metrics.value.closed || 0,
  },
  {
    key: 'conversion_rate',
    label: t('CONVERSATION.OPERATIONS.METRICS.CONVERSION'),
    value: `${metrics.value.conversion_rate || 0}%`,
  },
]);

onMounted(async () => {
  try {
    const { data } = await OperationalMetricsApi.get();
    metrics.value = data;
  } finally {
    isLoading.value = false;
  }
});
</script>

<template>
  <section
    class="grid shrink-0 grid-cols-2 gap-2 border-b border-n-weak bg-n-background px-3 py-2 sm:grid-cols-3 xl:grid-cols-5"
    :aria-busy="isLoading"
  >
    <article
      v-for="card in cards"
      :key="card.key"
      class="rounded-lg border border-n-weak bg-n-solid-1 px-3 py-2"
    >
      <p class="text-xs text-n-slate-11">{{ card.label }}</p>
      <p class="text-xl font-medium text-n-slate-12">
        {{
          isLoading ? t('CONVERSATION.OPERATIONS.METRICS.LOADING') : card.value
        }}
      </p>
    </article>
  </section>
</template>
